import {
  NBS_API_TRACK_AFFILIATE_CLICK_REQUEST,
  NBS_API_TRACK_AFFILIATE_CLICK_SUCCESS,
  NBS_API_TRACK_AFFILIATE_CLICK_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_TRACK_AFFILIATE_CLICK_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_TRACK_AFFILIATE_CLICK_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_TRACK_AFFILIATE_CLICK_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    default:
      return state;
  }
}
